import * as React from "react";

import { InstantAnswerContext } from "../../../types";

export const LazyPayoutModal = React.lazy<
  React.ComponentType<InstantAnswerContext>
>(() =>
  import(/* webpackChunkName: "payout-modal-view" */ "./PayoutModal").then(
    (module) => {
      return {
        default: module.PayoutModal,
      };
    }
  )
);
